import api from "./apiService";

export function getListing(page, limit, status, listingName) {
  return api
    .get(
      `admin/listings/?status=${status}&title=${listingName}&page=${page}&limit=${limit}`
    )
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function approveListing(listingId) {
  return api
    .patch(`admin/listings/approve/${listingId}`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function updateCoverImage(listingId, body) {
  return api
    .patch(`admin/listings/cover-image/${listingId}`, body)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function declineListing(listingId, data) {
  return api
    .patch(`admin/listings/decline/${listingId}`, data)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function activateListing(listingId) {
  return api
    .patch(`admin/listings/activate/${listingId}`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function deactivateListing(listingId) {
  return api
    .patch(`admin/listings/deactivate/${listingId}`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function deactivateASharedSpace(apartmentId) {
  return api
    .patch(`admin/listings/apartment/status/${apartmentId}`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function getListingDetail(listingId) {
  return api
    .get(`admin/listings/${listingId}`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function addComment(listingId, data) {
  return api
    .patch(`admin/listings/good-to-know/${listingId}`, data)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function deleteListing(listingId) {
  return api
    .delete(`admin/listings/${listingId}`)
    .then(data => {
      return data.data;
    })
    .catch(err => {
      return err.response;
    });
}

export function addCommissionFee(payload){
  return api
  .post(`admin/bookings/commission`, payload)
  .then(data => {
    return data.data;
  })
  .catch(error => {
    return error.response;
  });
}

export function updateCommissionFee(payload){
  return api
  .patch(`admin/bookings/commission`, payload)
  .then(data => {
    return data.data;
  })
  .catch(error => {
    return error.response;
  });
}

export function massDeleteListing(payload){
  return api
  .delete(`admin/listings/mass-delete`, {data: payload})
  .then(data => {
    return data.data;
  })
  .catch(error => {
    return error.response;
  });
}

export function verificationStatus(listingId, body){
  return api
  .patch(`admin/listings/verification-status/${listingId}`, body)
  .then(data => {
    return data.data;
  })
  .catch(error => {
    return error.response;
  });
}



//////////////////
// WEBPACK FOOTER
// ./services/listing.js
// module id = null
// module chunks = 